import renderTickets from '@components/ticket/render-tickets';
import { StyledIcon } from '@elements/icon/icon.styles';
import { Box } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';
import EmptyTicket from '@images/empty-ticket.svg';
import { Typography } from '@elements';
import num_word from '@utils/num_word';
import { Link } from 'react-router-dom';
import { useEventSessionById } from '@hooks/useEventSessions';
import Loader from '@components/loader/Loader';

const EventDetails = () => {
  const { eventId } = useParams();
  const eventSessionId = eventId ? Number(eventId) : undefined;
  const [returnedTicketUuids, setReturnedTicketUuids] = React.useState<Set<string>>(new Set());

  const { data, isFetching, isError } = useEventSessionById(
    Number.isFinite(eventSessionId) ? eventSessionId : undefined
  );

  const handleRefundSuccess = React.useCallback((ticketUuid: string) => {
    setReturnedTicketUuids((prev) => new Set(prev).add(ticketUuid));
  }, []);

  const eventSession = data
    ? {
        ...data,
        seats: (data.seats ?? []).filter((s) => s.ticketUuid && s.active),
      }
    : null;

  const ticketsCounts = eventSession ? (eventSession.seats ?? []).length : 0;

  if (isFetching && !data) {
    return <Loader isShowLoader />;
  }

  if (!eventSession || isError) {
    return (
      <Box>
        <Typography color="white" fontSize={22} fontWeight={400}>
          Мероприятие не найдено
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography color="white" fontSize={22} fontWeight={400}>
        У вас {ticketsCounts}{' '}
        {num_word(ticketsCounts, ['билет', 'билета', 'билетов'])}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          columnGap: '12px',
          rowGap: '32px',
          mt: '26px',
          flexWrap: 'wrap',
          justifyContent: { xs: 'center', md: 'start' },
        }}
      >
        {(renderTickets(eventSession, undefined, { returnedTicketUuids, onRefundSuccess: handleRefundSuccess }) ?? []).flat()}
        <Link to={`${process.env.ticketsUrl}/events/${eventId}`} target="_blank">
          <StyledIcon src={EmptyTicket} width={288} height={352} />
        </Link>
      </Box>
    </Box>
  );
};

export default EventDetails;
